// components/AddEventDialog.jsx
import React, { Component } from "react";
import {
    Dialog, DialogBody, DialogFooter,
    Button, RadioGroup, Radio,
    FormGroup, InputGroup, TextArea
} from "@blueprintjs/core";

import UISelect from "./UISelect";           // ← selectorul furnizat
import { MultiSelect } from "@blueprintjs/select";
import { BASE_API } from "../utils/constants";

import "../css/Popup.scss";

/* helpers */
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/* opțiuni */
const TRAINING_TYPES = [
    { id: "tehnic", name: "Tehnic" }, { id: "tactic", name: "Tactic" },
    { id: "fizic", name: "Fizic" }, { id: "recuperare", name: "Recuperare" }
];
const HOME_AWAY = [{ id: "acasa", name: "Acasă" },
{ id: "deplasare", name: "Deplasare" }];
const GAME_TYPES = [
    { id: "campionat", name: "Campionat" },
    { id: "amical", name: "Amical" },
{ id: "cupa", name: "Cupă" }];


export default class AddEventDialog extends Component {
    constructor(p) {
        super(p);
        /* data pre-selectată din calendar */
        const preset = p.defaultDate
            ? (typeof p.defaultDate === "string"
                ? p.defaultDate.slice(0, 10)
                : iso(p.defaultDate))
            : iso(new Date());

        this.state = {
            type: "training",

            date: preset,
            time: "10:00",
            location: "",

            /* training */
            training_type: [],
            description: "",

            /* game */
            opponent: "",
            home_away: HOME_AWAY[0],     // default Acasă
            game_type: GAME_TYPES[0],     // default Amical
            training_duration: 90,
            team_score: "",              // scor echipa mea
            opponent_score: "",
        };
    }

    /* când calendarul trimite o nouă dată */
    componentDidUpdate(prevP) {
        if (this.props.isOpen && this.props.defaultDate !== prevP.defaultDate) {
            const newDate = this.props.defaultDate
                ? (typeof this.props.defaultDate === "string"
                    ? this.props.defaultDate.slice(0, 10)
                    : iso(this.props.defaultDate))
                : iso(new Date());
            this.setState({ date: newDate });
        }
    }

    /* validare minimală */
    isValid = () => {
        const { type, opponent } = this.state;
        if (type === "game" && !opponent.trim()) return false;
        return true;
    };

    /* toggle Training MultiSelect */
    handleTraining = (item) => {
        this.setState(s => {
            const exist = s.training_type.some(t => t.id === item.id);
            return {
                training_type: exist
                    ? s.training_type.filter(t => t.id !== item.id)
                    : [...s.training_type, item]
            };
        });
    };

    /* payload */
    payload() {
        const { teamId } = this.props;
        const {
            type, date, time, location,
            training_type, description,
            opponent, home_away, game_type, training_duration
        } = this.state;
        const team_score = this.state.team_score === "" ? null : Number(this.state.team_score);
        const opponent_score = this.state.opponent_score === "" ? null : Number(this.state.opponent_score);

        let result = null;
        if (team_score !== null && opponent_score !== null) {
            if (team_score > opponent_score) result = "W";
            else if (team_score === opponent_score) result = "D";
            else result = "L";
        }



        return {
            team_id: teamId,
            type,
            date,
            time_start: time,
            location: location || null,

            training_type: training_type.map(t => t.id).join(",") || null,
            training_duration,
            description: description || null,

            opponent: opponent || null,
            home_away: home_away.id,
            game_type: game_type.id,

            /* … restul câmpurilor … */
            team_score,
            opponent_score,
            result

        };
    }

    /* save */
    save = async () => {
        const r = await fetch(`${BASE_API}/api/events`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(this.payload())
        });
        r.ok ? this.onClose(true)
            : alert((await r.json()).error || "Eroare la salvare");


    };

    /* ───────────────── RENDER ───────────────── */
    onClose = (isClosed) => {
        this.setState({
            date: this.preset,
            location: '',
            training_type: [],
            description: '',
            opponent: '',
            home_away: HOME_AWAY[0],     // default Acasă
            game_type: GAME_TYPES[0],
            training_duration: 90
        })
        this.props.onClose(isClosed)
    }

    swapTeams = () => {
        this.setState(s => ({
            // opponent: s.opponent,               // rămâne acelaşi text
            home_away: s.home_away.id === "acasa" ? HOME_AWAY[1] : HOME_AWAY[0],
            // team_score: s.opponent_score,
            // opponent_score: s.team_score,
        }));
    };

    handleScoreChange = (field) => (e) =>
        this.setState({ [field]: e.target.value.replace(/[^0-9]/g, "") });


    render() {
        // console.log(this.state)
        const { isOpen } = this.props;
        const s = this.state, isTraining = s.type === "training";

        return (
            <Dialog isOpen={isOpen} onClose={() => this.onClose(false)}
                title={`Adauga ${s.type === 'training' ? ' antrenament' : 'joc'}`} className="fm-dialog" canOutsideClickClose={false}>
                <DialogBody>

                    {/* TIP */}
                    <FormGroup >
                        <RadioGroup inline selectedValue={s.type}
                            onChange={e => this.setState({ type: e.target.value })}>
                            <Radio value="training" label="Antrenament" className={`${s.type === 'training' ? 'active' : ''}`} />
                            <Radio value="game" label="Joc" className={`${s.type === 'game' ? 'active' : ''}`} />
                        </RadioGroup>
                    </FormGroup>

                    {!isTraining && (
                        <>

                            {/* ================================== Echipe & switch === */}
                            <FormGroup label="Echipe" className="m-top-1r flex-display">
                                <div className="teams-row">
                                    {/* echipa mea (read-only) */}
                                    <InputGroup
                                        className={`fm-input team-input ${s.home_away.id === "acasa" ? 'order-1' : 'order-3'}`}
                                        readOnly
                                        value={JSON.parse(localStorage.getItem("session"))?.team?.name || "Echipa Mea"}
                                    />

                                    {/* buton swap */}
                                    <Button
                                        icon="swap-horizontal"
                                        minimal
                                        onClick={this.swapTeams}
                                        title="Schimbă gazdă / oaspete"
                                        className="swap-btn order-2"
                                    />

                                    {/* adversar editabil */}
                                    <InputGroup
                                        className={`fm-input team-input ${s.home_away.id === "acasa" ? 'order-3' : 'order-1'}`}
                                        placeholder="ex: Dinamo"
                                        value={this.state.opponent}
                                        onChange={(e) => this.setState({ opponent: e.target.value })}
                                    />
                                </div>
                            </FormGroup>

                            {/* === Scor === */}
                            <FormGroup className="m-bottom-1r">
                                <div className="score-row">
                                    <InputGroup
                                        className={`fm-input score-input ${s.home_away.id === "acasa" ? 'order-1' : 'order-3'}`}
                                        type="number"
                                        min={0}
                                        value={this.state.team_score}
                                        onChange={this.handleScoreChange("team_score")}
                                        placeholder="?"
                                    />
                                    <span className="score-sep  order-2">–</span>
                                    <InputGroup
                                        className={`fm-input score-input ${s.home_away.id === "acasa" ? 'order-3' : 'order-1'}`}
                                        type="number"
                                        min={0}
                                        value={this.state.opponent_score}
                                        onChange={this.handleScoreChange("opponent_score")}
                                        placeholder="?"
                                    />
                                </div>
                            </FormGroup>







                        </>
                    )}
                    {/* DATA + ORĂ */}
                    <div className="row-group">


                        <FormGroup label="Data">
                            <div className="date-wrapper">
                                <input type="date"
                                    value={s.date}
                                    onChange={e => this.setState({ date: e.target.value })}
                                    style={{ width: "100%" }} />
                                <img src="/icons/calendar-white.png" className="calendar-icon" />
                            </div>
                        </FormGroup>

                        <FormGroup label="Ora">
                            <input type="time" step="900" className="bp5-input"
                                value={s.time}
                                onChange={e => this.setState({ time: e.target.value })}
                                style={{ width: "100%" }} />
                        </FormGroup>
                    </div>

                    {/* LOCAȚIE liberă (teren / sală) */}
                    <FormGroup label="Locație">
                        <InputGroup value={s.location}
                            className="fm-input"
                            placeholder="ex: Teren 1"
                            onChange={e => this.setState({ location: e.target.value })} />
                    </FormGroup>

                    {/* TRAINING */}
                    {isTraining && (
                        <>
                            <FormGroup label="Durată (minute)">
                                <InputGroup
                                    className="fm-input"
                                    type="number"
                                    min={0}
                                    max={199}
                                    value={s.training_duration}
                                    onChange={e => this.setState({ training_duration: e.target.value })}
                                    placeholder="Ex: 90"
                                />
                            </FormGroup>
                            <div className='fm-multiselect'>
                                <FormGroup label="Tip antrenament">
                                    <MultiSelect
                                        items={TRAINING_TYPES}
                                        selectedItems={s.training_type}
                                        tagRenderer={t => t.name}
                                        itemRenderer={(item, { handleClick, modifiers }) => (
                                            <Button key={item.id}
                                                text={item.name}
                                                active={modifiers.active}
                                                onClick={handleClick}
                                                minimal fill />
                                        )}
                                        onItemSelect={this.handleTraining}
                                        placeholder="Selectează..."
                                        fill
                                        popoverProps={{

                                            minimal: true,
                                            matchTargetWidth: true,
                                            usePortal: false
                                        }}
                                    />
                                </FormGroup>
                            </div>


                        </>
                    )}

                    {/* GAME */}
                    {!isTraining && (
                        <>

                            <FormGroup label="Tip joc">
                                <UISelect
                                    items={GAME_TYPES}
                                    selectedItem={s.game_type}
                                    onItemSelect={(it) => this.setState({ game_type: it })} />
                            </FormGroup>


                        </>
                    )}
                    <FormGroup label="Descriere">
                        <TextArea
                            fill growVertically
                            value={s.description}
                            onChange={e => this.setState({ description: e.target.value })} />
                    </FormGroup>

                </DialogBody>

                <DialogFooter
                    actions={
                        <>
                            <Button minimal text="Anulează"
                                onClick={() => this.onClose(false)} />
                            <Button intent="primary" text="Salvează"
                                disabled={!this.isValid()}
                                onClick={this.save} />
                        </>
                    } />
            </Dialog>
        );
    }
}
